module.exports = __webpack_public_path__ + "static/media/cancelOrder.8275ad2d.svg";